import type { AppMessages } from "@/i18n/ja";
import { statsSections } from "./statsCatalog";
import type { StatsSnapshot } from "./statsSnapshot";

export function renderStatsPanel(
  container: HTMLElement,
  stats: StatsSnapshot,
  messages: AppMessages,
): void {
  container.replaceChildren();

  for (const section of statsSections) {
    const visibleEntries = section.entries
      .map((entry) => ({
        label: entry.getLabel(messages),
        value: entry.getValue(stats, messages),
      }))
      .filter((row) => row.value !== null);

    if (visibleEntries.length === 0) continue;

    const sectionEl = document.createElement("div");
    sectionEl.className = "hover-idle-stats-section";
    sectionEl.dataset.section = section.id;

    const header = document.createElement("div");
    header.className = "hover-idle-stats-section-header";

    const heading = document.createElement("h3");
    heading.className = "hover-idle-stats-section-heading";
    heading.textContent = section.getLabel(messages);
    header.append(heading);
    sectionEl.append(header);

    const list = document.createElement("dl");
    list.className = "hover-idle-stats-list";

    for (const row of visibleEntries) {
      const dt = document.createElement("dt");
      dt.className = "hover-idle-stats-label";
      dt.textContent = row.label;

      const dd = document.createElement("dd");
      dd.className = "hover-idle-stats-value";
      dd.textContent = row.value as string;

      list.append(dt, dd);
    }

    sectionEl.append(list);
    container.append(sectionEl);
  }
}
